exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nil-sa-templates-collectinformation-style__collectInformation{width:100%}", ""]);

// exports
exports.locals = {
	"collectInformation": "nil-sa-templates-collectinformation-style__collectInformation"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-2!../node_modules/postcss-loader/lib??ref--2-3!../node_modules/less-loader/dist/cjs.js??ref--2-4!./components/templates/CollectInformation/style.less
// module id = 509
// module chunks = 0